import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/shared/api';
import { TokenStorageService } from 'src/app/shared/token-storage';
import { CommonService } from '../shared/common.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'dashboard-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  form: any = {
    email: '', // 'andreas@die.app',
    lost: false,
    password: '',// 'andreas@die.app'
  }
  isLoggedIn = false;
  isLoginFailed = false;
  errorMessage = '';
  roles: string[] = [];

  error: boolean = false;
  version: string = '';

  constructor(
    public commonService: CommonService,
    private apiService: ApiService,
    private tokenStorage: TokenStorageService,
    public router: Router,
  ) {
    this.version = environment.version;
  }

  ngOnInit() {
    if (this.tokenStorage.getToken()) {
      this.isLoggedIn = true;
      this.roles = this.tokenStorage.getUser().backendRoles;
    }
  }

  sendLoginForm() {
    this.error = false;
    const { email, password } = this.form;
    this.apiService
      .login(email, password)
      .subscribe(
        data => {
          console.log(data);
          let authResponse: any = data;
          this.tokenStorage.saveToken(authResponse.accessToken);
          this.tokenStorage.saveUser(authResponse.user);
          this.isLoginFailed = false;
          this.isLoggedIn = true;
          this.roles = this.tokenStorage.getUser().backendRoles;

          this.commonService.setUser({
            email: this.tokenStorage.getUser().email
          })
          
          this.router.navigateByUrl("/admin/dashboard")
        },
        err => {
          this.error = true;
        }
      );
  }


  resetPasswordForm() {
    const { email } = this.form;
    this.apiService
      .requestPasswordReset(email)
      .subscribe(
        data => {
          this.reloadPage();
        },
        err => {
          this.error = true;
        }
      );
  }
  reloadPage(): void {
    // this.router.navigateByUrl("/admin/dashboard");
    window.location.reload();
  }

}
